import apiHandler from "../core/apiHandler";

/**
 * ✍️ QZ Tray Signature API
 * Maneja las peticiones relacionadas con la firma y verificación digital
 * de payloads enviados a QZ Tray.
 *
 * ✅ Endpoints principales:
 * - POST /sign → Genera firma digital del payload
 * - POST /verify → Verifica una firma digital
 */
const qzTraySignatureApi = apiHandler("qztray");

export default qzTraySignatureApi;
